import Vue from 'vue'
import Bugsnag from '@bugsnag/js'
import BugsnagPluginVue from '@bugsnag/plugin-vue'
import getDeviceId from 'utils/getDeviceId'
import store from 'store'

const deviceId = getDeviceId()
Bugsnag.start({
  maxEvents: 20,
  apiKey: '3b5c729edd509161c152f4771962a054',
  appVersion: process.env.__version__,
  releaseStage: process.env.BUILD_TYPE,
  collectUserIp: true,
  enabledErrorTypes: {
    unhandledExceptions: true,
    unhandledRejections: true
  },
  plugins: [new BugsnagPluginVue()],
  onError(evt) {
    if (evt.originalError?.aborted) {
      return false
    }

    evt.addMetadata('env', {
      deviceId,
      account: store.getters.curAccountId,
      virtual: store.getters.isVirtual,
      funded: store.getters.isDeposited
    })

    evt.addMetadata('permission', {
      hkLv2: store.getters.hasHkLv2Permission,
      hkLv0: store.getters.hasHkLv0Permission,
      usLv1: store.getters.hasUsLv1Permission,
      usLv2: store.getters.hasUsLv2Permission,
      usOption: store.getters.hasUsOptionPermission,
      usOptTrade: store.getters.hasUsOptTradePermission,
      hkTrade: store.getters.hasHkTradePermission
    })

    evt.addMetadata('portfolio', {
      watchlistCount: (store.getters.watchListAll || []).length,
      holdingsCount: (store.getters.holdings || []).length,
      hasAsset: !!store.getters.asset
    })

    evt.setUser(store.getters.curAccountId, '***', store.getters.username)
  }
})
const bugsnagVue = Bugsnag.getPlugin('vue')
bugsnagVue.installVueErrorHandler(Vue)

Vue.log = Bugsnag.notify
